module.exports = __webpack_public_path__ + "static/media/radiohaifa.2127fb70.png";